import React from 'react';
import { ShieldCheckIcon } from './icons';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="guarantee-heading" data-id="element-83" data-mp="4w1hevzztakf">
      <div className="mx-auto max-w-3xl px-6" data-id="element-84" data-mp="9tl6kqy8b7r5">
        <div className="rounded-4xl border border-gold/35 bg-blush px-7 py-11 text-center sm:px-12" data-id="element-85" data-mp="etfwar69pram">
          <Medallion icon={ShieldCheckIcon} data-id="element-86" data-mp="jsip9d8z4728" />
          <h2 id="guarantee-heading" className="mt-5 font-display text-3xl leading-tight text-charcoal sm:text-4xl" data-id="element-87" data-mp="jrr651wkc1su">
            7-Day Risk-Free Guarantee
          </h2>
          <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-ash" data-id="element-88" data-mp="skcbngb6obzq">
            Open the library, explore the 7 bonuses, and use the material in
            your most demanding class this week. If it doesn’t deliver what we
            promise here, write to us within 7 days and we refund{' '}
            <span className="font-medium text-wine" data-id="element-89" data-mp="17j6bl3jmyz8b">100% of your money</span>.
          </p>
          <p className="mx-auto mt-5 max-w-lg font-display text-xl italic leading-snug text-wine" data-id="element-90" data-mp="25s6z2aurn14o">
            You risk nothing but the time it takes to open the first volume.
          </p>
        </div>
      </div>
    </section>;
}